/* eslint-disable no-unused-vars */
// Keeping these unused variables so the codec page is shown
define('codec/codec',['require','exports','module','knockout','web-urls','lodash'],function (require, exports, module) {
    /* eslint-enable */
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var _ = require('lodash');

    var self = this;
    self.windowsCodecUrl = webUrls.get('windows.codec.url');
    self.macCodecUrl = webUrls.get('mac.codec.url');

    self.isMac = ko.observable(_.contains(navigator.userAgent.toLowerCase(), 'mac'));
});

